export enum AuditSeverity {
	Trace="TRACE",
	Debug="DEBUG",
	Information="INFORMATION",
	Warning="WARNING",
	Error="ERROR",
}
